<script>
export default {
	props: {
		source: {
			type: String,
			default: ''
		},
		alt: {
			type: String,
			default: 'Image'
		},
		pictureClass: {
			type: String,
			default: ''
		}
	},
	
	data() {
		return {
			state: {
				loaded: false
			}
		};
	},
	methods: {
		observe() {
			const observer = new IntersectionObserver((entries, imgObserver) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						this.load();
						imgObserver.unobserve(entry.target);
					}
				});
			});
				
			observer.observe(this.$refs.container);
		},
		load() {
			this.state.loaded = true;
		}
	},
	mounted() {
		if (this.$refs.image.complete) {
			this.observe();
		}
	}
};
</script>
<template>
	<picture
		ref="container"
		class="lazy js-lazy"
		:class="{
			'loaded': !!state.loaded
		}"
	>
		<img
			ref="image"
			:src="source"
			:alt="alt"
			loading="lazy"
			@load="observe"
		>
	</picture>
</template>
